<template>
  <div class="dialog-wrapper">
    <h1 class="text-xl center">训练指导</h1>
    <div class="qrcode center">
      <img :src="qrcode" alt="二维码" />
      <div>客服电话：{{ phone }}</div>
    </div>
    <ul class="tips">
      <li>
        <span class="order">1</span>
        <span class="tip">添加训练师微信，发送相关检查报告。</span>
      </li>
      <li>
        <span class="order">2</span>
        <span class="tip">训练师根据报告，制定个性化训练方案。</span>
      </li>
      <li>
        <span class="order">3</span>
        <span class="tip">根据个性化方案，进行训练。</span>
      </li>
    </ul>
    <div class="button center">
      <el-button type="primary" round @click="handleConfirm">确认</el-button>
    </div>
  </div>
</template>
<script>
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
@Component
export default class TrainerWechatDialog extends Vue {
  @Prop(String)
  qrcode

  @Prop({ type: String, default: '010-86460487' })
  phone

  @Emit('confirm')
  handleConfirm() {}
}
</script>
<style lang="scss" scoped>
.dialog-wrapper {
  // text-align: center;
}
.text-xl {
  font-weight: 400;
  color: #595ed3;
}
.qrcode {
  width: 200px;
  height: 220px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 1px dashed #606266;
  padding: 10px;
  img {
    width: 100%;
  }
}
.tips {
  list-style: none;
  margin: 0 auto;
  width: 400px;
}
.order {
  width: 16px;
  height: 16px;
  background: #595ed3;
  display: inline-block;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  margin-right: 5px;
}
.tip {
  line-height: 2;
}
.center {
  text-align: center;
}
.el-button {
  background: #595ed3;
  width: 400px;
}
.button {
  margin-top: 30px;
}
</style>
